import { render, staticRenderFns } from "./statusLogsTable.vue?vue&type=template&id=00a87bbe&scoped=true&"
import script from "./statusLogsTable.vue?vue&type=script&lang=js&"
export * from "./statusLogsTable.vue?vue&type=script&lang=js&"
import style0 from "./statusLogsTable.vue?vue&type=style&index=0&id=00a87bbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a87bbe",
  null
  
)

export default component.exports